import type { IntlShape } from 'react-intl';
import { create } from 'zustand';

import type { AccountType, EInvoicingDetailType } from '@/api/schema';

export type UserState = {
    account: AccountType | null;
    isEligible: boolean;
    isRegistrationNumberRequired: boolean;
    setAccount: (profile: AccountType | null) => void;
    currency: string;
    setCurrency: (currency: string) => void;
    countryLocale: string;
    countryIntl: IntlShape | undefined;
    setCountryIntl: (locale: string | undefined, intl: IntlShape | undefined) => void;
    eInvoicingDetails: EInvoicingDetailType[] | null;
    setEInvoicingDetails: (eInvoicingDetails: EInvoicingDetailType[]) => void;
};

export const checkPermission = (account: AccountType | null, permission: string): boolean =>
    !!account?.permissions?.find(f => f === permission);

export const useUserStore = create<UserState>()(set => ({
    account: null,
    isEligible: false,
    isRegistrationNumberRequired: false,
    setAccount: (profile: AccountType | null) =>
        set(() => ({
            account: profile,
            isEligible: profile?.isOnboardAllowed ?? false,
            isRegistrationNumberRequired: profile?.isRegistrationNumberRequired,
        })),
    currency: '',
    setCurrency: (currency: string) =>
        set(() => ({
            currency,
        })),
    countryLocale: '',
    countryIntl: undefined,
    setCountryIntl: (locale: string | undefined, intl: IntlShape | undefined) =>
        set(() => ({
            countryLocale: locale,
            countryIntl: intl,
        })),
    eInvoicingDetails: null,
    setEInvoicingDetails: (eInvoicingDetails: EInvoicingDetailType[]) =>
        set(() => ({
            eInvoicingDetails,
        })),
}));
